/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Input, ChangeDetectionStrategy, TemplateRef, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { StringUtilities } from 'app/shared/helpers/string-helpers';

@Component({
    selector: 'kaleida-popover',
    styleUrls: ['./pop-over.component.scss'],
    templateUrl: './pop-over.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('popoverTrigger', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate(300, style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate(300, style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class KaleidaPopoverComponent {

  @Input() text = '';
  @Input() header = '';
  @Input() footer = '';
  @Input() popoverData = {ddata: 23};
  @Input() contentTemplate: TemplateRef<any>;

  constructor() {
  }


  convertString(source: string): string {
    return StringUtilities.translateCR(source);
  }

}
